import { Logger, engineComponent } from "neo-common";
import { ComponentTypes } from "../../Components/ComponentTypes";

/**
 * HtmlStyle holds basic properties for all kind of html styles.
 * @class HtmlStyle
 */
@engineComponent(ComponentTypes.HtmlStyle)
export class HtmlStyle {
    /**
     * Get attributes from xml and set up supported properties.
     * @method create
     * @param node is Element from xml
     * @retutn void
     */
    create(node: Element): void {}

    /**
     * Trace to browser console.
     * @method log
     * @param s string
     * @retutn void
     */
    protected log(s: string): void {
        if (DEBUG) {
            var compName = (this as any).__componentName__;
            Logger.debugGroup(compName, s);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/HTMLComponents/Styles/HtmlStyle.ts
 **/